import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import moment from "moment";

import {markUpDownContextAction, useMarkUpContext} from "./FeaturesSetupMarkUpContext";
import FeaturesSetupMarkPopupHeaderCheckboxes from "./FeaturesSetupMarkPopupHeaderCheckboxes";
import {featuresSetupUpdateFeatures} from "../featuresActions";
import {createNewMarkUpItem} from "./markUpFunctions";
import {replaceArrayObject} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";


const FeaturesSetupMarkPopupHeader = (props) => {

  const {intl} = props;
  const {markUpDownContextState, markUpDownContextDispatch} = useMarkUpContext();
  const {markUpDownInputValue, upDownCheckboxValue, currencyPercentageCheckboxValue, applyToValue, markUpList,
    activeMarkUpItemIndex} = markUpDownContextState;

  const markUpDownInputChange = (event) => {
    const value = +event.target.value;
    markUpDownContextDispatch(markUpDownContextAction({
      markUpDownInputValue: value
    }));
  }

  const updateButtonClick = () => {
    const newMarkUpItem = Object.assign({}, markUpList[activeMarkUpItemIndex], {
      type: upDownCheckboxValue,
      priceType: currencyPercentageCheckboxValue,
      value: markUpDownInputValue,
      applyTo: applyToValue,
      updated: moment().unix(),
    })
    markUpDownContextDispatch(markUpDownContextAction({
      markUpList: replaceArrayObject(markUpList, newMarkUpItem, "id"),
    }))
  }

  const addClick = () => {
    markUpDownContextDispatch(markUpDownContextAction({
      markUpList: [...markUpList, createNewMarkUpItem(applyToValue, upDownCheckboxValue, currencyPercentageCheckboxValue, markUpDownInputValue)],
    }))
  }

  const updateDisabled = !markUpList[activeMarkUpItemIndex] || (
    (markUpList[activeMarkUpItemIndex].type === upDownCheckboxValue)
    && (markUpList[activeMarkUpItemIndex].priceType === currencyPercentageCheckboxValue)
    && (markUpList[activeMarkUpItemIndex].value === markUpDownInputValue)
    && (markUpList[activeMarkUpItemIndex].applyTo === applyToValue)
  )

  return (
    <div className="fs-mark__header">
      <FeaturesSetupMarkPopupHeaderCheckboxes/>
      <div className="fs-shipping-setup">
        <input className="generic-popup-textbox fs-mark__header-input"
               placeholder={intl.formatMessage({
                 id: "features.setup.markUpDownPopup.checkbox." + currencyPercentageCheckboxValue
               })}
               maxLength={255}
               value={markUpDownInputValue || ""}
               onChange={markUpDownInputChange}/>
        <button className={"ui-button4 ui-button4--blue" + (updateDisabled ? " ui-button5--disabled" : "")}
                onClick={updateButtonClick}>
          <FormattedMessage id="messageBox.buttons.update"/>
        </button>
        <button className={"ui-button4 ui-button4--green"}
                onClick={addClick}>
          <FormattedMessage id="messageBox.buttons.add"/>
        </button>
      </div>
    </div>
  )
};


const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeatures,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupMarkPopupHeader)
)
